import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/* -------- DATA -------- */
const ordersByBuyerType = [
  { name: "Builder", value: 145, percentage: 48 },
  { name: "End Home", value: 98, percentage: 32 },
  { name: "Contractor", value: 62, percentage: 20 },
];

const gmvByBuyerType = [
  { type: "Builder", gmv: 320000, orders: 145 },
  { type: "End Home", gmv: 180000, orders: 98 },
  { type: "Contractor", gmv: 150000, orders: 62 },
];

const COLORS = ["#2563eb", "#10b981", "#f59e0b"];

export default function OrderAnalyticsSection() {
  return (
    <div className="space-y-4 md:space-y-8">

      {/* HEADER */}
      <div className="flex items-center justify-between">
        <h2 className="text-lg md:text-2xl font-bold">Order Analytics</h2>
        <select className="border rounded-md px-3 py-2 text-sm">
          <option value="week">This Week</option>
          <option value="month">This Month</option>
          <option value="quarter">This Quarter</option>
          <option value="year">This Year</option>
        </select>
      </div>

      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {ordersByBuyerType.map((item, index) => (
          <div
            key={index}
            className="bg-white border rounded-xl p-4 shadow-sm"
          >
            <p className="text-sm text-gray-500">{item.name} Orders</p>
            <p className="text-lg md:text-2xl font-bold mt-1">{item.value}</p>
            <p className="text-xs text-gray-600 mt-1">
              {item.percentage}% of total orders
            </p>
          </div>
        ))}
      </div>

      {/* CHARTS */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6">

        {/* PIE CHART */}
        <div className="bg-white border rounded-xl p-4">
          <h3 className="font-semibold mb-4">
            Orders Distribution by Buyer Type
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={ordersByBuyerType}
                dataKey="value"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={({ name, percentage }) =>
                  `${name}: ${percentage}%`
                }
              >
                {ordersByBuyerType.map((_, index) => (
                  <Cell
                    key={index}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* BAR CHART */}
        <div className="bg-white border rounded-xl p-4">
          <h3 className="font-semibold mb-4">
            GMV by Buyer Type
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={gmvByBuyerType}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="type" />
              <YAxis />
              <Tooltip
                formatter={(value) =>
                  `$${value.toLocaleString()}`
                }
              />
              <Legend />
              <Bar dataKey="gmv" fill="#2563eb" name="GMV" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border rounded-xl p-4">
        <h3 className="font-semibold mb-4">
          Buyer Type Summary
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left">
                <th className="py-3 px-4">Buyer Type</th>
                <th className="py-3 px-4">Total Orders</th>
                <th className="py-3 px-4">Total GMV</th>
                <th className="py-3 px-4">Avg Order Value</th>
                <th className="py-3 px-4">% of Total</th>
              </tr>
            </thead>
            <tbody>
              {gmvByBuyerType.map((item, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="py-3 px-4 font-medium">
                    {item.type}
                  </td>
                  <td className="py-3 px-4">
                    {item.orders}
                  </td>
                  <td className="py-3 px-4">
                    ${item.gmv.toLocaleString()}
                  </td>
                  <td className="py-3 px-4">
                    $
                    {Math.round(
                      item.gmv / item.orders
                    ).toLocaleString()}
                  </td>
                  <td className="py-3 px-4">
                    {ordersByBuyerType[index].percentage}%
                  </td>
                </tr>
              ))}

              {/* TOTAL ROW */}
              <tr className="font-bold bg-gray-50">
                <td className="py-3 px-4">Total</td>
                <td className="py-3 px-4">
                  {gmvByBuyerType.reduce(
                    (sum, i) => sum + i.orders,
                    0
                  )}
                </td>
                <td className="py-3 px-4">
                  $
                  {gmvByBuyerType
                    .reduce((sum, i) => sum + i.gmv, 0)
                    .toLocaleString()}
                </td>
                <td className="py-3 px-4">-</td>
                <td className="py-3 px-4">100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
